import type { UnreadBadgeItem } from "@/components/common/UnreadBadgeStack";
import type { ChatRoomResponse } from "@/lib/humhub-api/types";

export const getUnreadCounts = (room: ChatRoomResponse) => ({
  unreadMessages: room.unread_message_count ?? 0,
  unreadMentions: room.unread_mention_count ?? 0,
});

export const buildUnreadBadgeItems = (
  t: (key: string) => string,
  unreadMessages: number,
  unreadMentions: number,
): UnreadBadgeItem[] => [
  {
    count: unreadMessages,
    label: t("chat.unreadMessages"),
    variant: "unreadActivity",
  },
  {
    count: unreadMentions,
    label: t("chat.unreadMentions"),
    variant: "mention",
    prefix: "@",
  },
];
